import { render } from "./BannerSection.vue?vue&type=template&id=8a111aae&scoped=true"
import script from "./BannerSection.vue?vue&type=script&lang=js"
export * from "./BannerSection.vue?vue&type=script&lang=js"

import "./BannerSection.vue?vue&type=style&index=0&id=8a111aae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a111aae"]])

export default __exports__